// src/components/Footer.js
import React from 'react';
import { Typography, Link, Box, useTheme, Container } from '@mui/material';

function Footer() {
  const year = new Date().getFullYear();
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2.5,
        px: 3,
        backgroundColor: 'transparent',
        borderTop: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#e5e7eb'}`,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
            [theme.breakpoints.down('md')]: {
              flexDirection: 'column',
              alignItems: 'flex-start',
            },
          }}
        >
          {/* Copyright */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                color: theme.palette.text.secondary,
                fontSize: '0.875rem',
              }}
            >
              © {year}
            </Typography>
            <Link 
              href="https://kloneit.net" 
              target="_blank" 
              rel="noopener noreferrer"
              underline="none"
              sx={{
                color: '#3b82f6',
                fontWeight: 600,
                fontSize: '0.875rem',
                '&:hover': {
                  color: '#2563eb',
                },
              }}
            >
              KlonIT
            </Link>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '0.875rem' }}>
              • Clone. Scale. Grow
            </Typography>
          </Box>

          {/* Links */}
          <Box 
            sx={{ 
              display: 'flex', 
              gap: 3,
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {[
              { label: 'Support', href: '/support' },
              { label: 'Help Center', href: '/help' },
              { label: 'Privacy', href: '/privacy' },
              { label: 'Terms', href: '/terms' },
              { label: 'WordPress Plugin', href: '/wordpress-plugin' },
              { label: 'Documentation', href: 'https://docs.klonit.ai/', external: true },
            ].map((link, index) => (
              <Link
                key={index}
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noopener noreferrer" : undefined}
                underline="none"
                sx={{
                  color: theme.palette.text.secondary,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#3b82f6',
                  },
                }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;